import React from 'react';

import { useThemeContext } from '../contexts/ThemeContextProvider';

const Button = ({ icon, bgColor, color, bgHoverColor, size, text, borderRadius, width, clicked = ()=>{} }) => {
  const { setIsClicked, initialState } = useThemeContext();

  return (
    <button
      type="button"
      onClick={async() => {await clicked();setIsClicked(initialState);}}
      style={{ backgroundColor: bgColor, color, borderRadius }}
      className={` text-${size} p-3 w-${width} hover:drop-shadow-xl hover:bg-${bgHoverColor}`}
    >
      {icon} {text}
    </button>
  );
};

export default Button;
